<template>
  <div >
    <div class="bodytopBox">
      <div class="bodytopBox1">
        <img src="../../../static/image/logo.png" class="bodytopBox1_1" />
        <div class="bodytopBox1_2">用户注册</div>
        <div class="bodytopBox1_3">已有卡丁生活账号?</div>
        <div class="bodytopBox1_4" @click="login()">登录</div>
      </div>
    </div>
    <div class="bodyBox">
      <div class="bodyBox1">
        <div class="bodyBox1_1">手机号</div>
        <el-input v-model="phone" placeholder="请输入手机号" class="bodyBox1_2" clearable></el-input>
      </div>
      <div class="bodyBox1">
        <div class="bodyBox1_1">验证码</div>
        <el-input v-model="yzm" placeholder="请输入验证码" class="bodyBox1_3" clearable></el-input>
        <div class="bodyBox1_4">获取验证码</div>
      </div>
      <div class="bodyBox1">
        <div class="bodyBox1_1">新密码</div>
        <el-input v-model="pwd" placeholder="请输入密码" class="bodyBox1_2" show-password></el-input>
      </div>
      <div class="bodyBox1">
        <div class="bodyBox1_1">确认密码</div>
        <el-input v-model="pwd1" placeholder="请输入再次密码" class="bodyBox1_2" show-password></el-input>
      </div>
      <div class="bodyBox1">
        <div class="bodyBox1_1"></div>
        <div class="submit">同意官方协议并注册</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        phone:"",
        yzm:"",
        pwd:"",
        pwd1:"",
      }
    },
    //初始化
    created(){

    },
    methods:{
      //登录
      login(){
        this.$router.push("/login")
      }
    }
  }
</script>

<style scoped>
  .bodytopBox{
    width: 100%;
    height: 100px;
    box-shadow: 0px 5px 10px #ccc;
  }
  .bodytopBox1{
    width: 1200px;
    height: 100px;
    margin: 0px auto;
    display: flex;
    align-items: center;
  }
  .bodytopBox1_1{
    width: 60px;
    height: 60px;
  }
  .bodytopBox1_2{
    width: 923px;
    font-size: 20px;
    font-weight: 600;
    margin-left: 10px;
  }
  .bodytopBox1_3{
    font-size: 16px;
    color: #666666;
  }
  .bodytopBox1_4{
    color: #FFFFFF;
    background-color: #FD8723;
    line-height: 30px;
    height: 30px;
    text-align: center;
    font-size: 14px;
    width: 60px;
    border-radius: 5px;
    margin-left: 10px;
  }
  .bodyBox{
    width: 1200px;
    margin: 100px auto 0px;
  }
  .bodyBox1{
    display: flex;
    align-items: center;
    height: 60px;
  }
  .bodyBox1_1{
    width: 300px;
    font-size: 16px;
    text-align: right;
    margin-right: 10px;
    height: 30px;
    line-height: 30px;
  }
  .bodyBox1_2{
    height: 30px;
    width: 300px;
    margin: 0px;
    margin-top: -10px;
    padding: 0px;
  }
  .bodyBox1_3{
    height: 30px;
    width: 180px;
    margin: 0px;
    margin-top: -10px;
    padding: 0px;
  }
  .bodyBox1_4{
    width: 100px;
    height: 40px;
    font-size: 14px;
    color: #ffffff;
    background-color: #FD8723;
    text-align: center;
    line-height: 40px;
    border-radius: 5px;
    margin-left: 20px;
  }
  .submit{
    width: 300px;
    height: 40px;
    font-size: 16px;
    color: #fff;
    background-color: #FD8723;
    line-height: 40px;
    text-align: center;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shoppingMall/register.vue